import {useIndicator} from "contexts/IndicatorsContext";
import React from "react";
import {ContentWidget} from "./content";

export const WidgetsIndicators = () => {

    const {indicators} = useIndicator();

    const totalIndicators = indicators.indicatorsEn.reduce((acumulator, object) => {
        return acumulator + object.value;
    }, 0);

    return (
        <div>
            <div className="row widgets-dashboard mt-4 gy-2">
                <div className="col-12 col-md-6 col-xl-12 col-xxl-6 ">
                    <ContentWidget
                        language="pt-BR"
                        indicators={indicators.indicatorsPt}
                    />
                </div>

                {totalIndicators > 0 &&
                    <div className="col-12 col-md-6 col-xl-12 col-xxl-6">
                        <ContentWidget
                            language="en-US"
                            indicators={indicators.indicatorsEn}
                        />
                    </div>
                }
            </div>
        </div>

    )
}
